import Stack from '@mui/material/Stack';

import Footer from '../components/Footer';
import Header from '../components/Header';

function SimpleLayout({ children }: { children: React.ReactNode }) {
  return (
    <Stack direction="column" justifyContent="space-between" flex={1}>
      <Header />
      {children}
      <Footer />
    </Stack>
  );
}

export default SimpleLayout;
